<template>
    <div class="takequiz">
    <h2> {{lang.welcome}}</h2>
    <button class="btn btn-lg btn-dark" v-on:click="beginQuiz()">{{lang.beginBtn}}</button>
    </div>
</template>
<script>
export default {
  name: 'StartQuiz',
  props: {
    lang: Object
  },
  methods:{
      beginQuiz: function() {
          this.$emit('start-quiz')
      }
  }
}
</script>

<style>

</style>
